var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIcon247SupportNwuj4Fhegt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9dcc6b;}.cls-2{fill:#84b749;}.cls-3{fill:#b5e08c;}.cls-4{fill:#6fabe6;}.cls-5{fill:#82bcf4;}.cls-6{fill:#edebf2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24-7 Support") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_24_7_Support",
    "data-name": "24/7 Support"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,39a6.06,6.06,0,0,1-6,5A23,23,0,0,1,1,22.12c-.13-2.4.33-4.48,2.37-6A5.62,5.62,0,0,1,6,15l7,7a6,6,0,0,1-6,5s0,0,0,0A18,18,0,0,0,18,38a6,6,0,0,1,5-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30,39a5.69,5.69,0,0,1-.83,2.17l-5.35-5.35c-1.69-1.69-4.49.64-5.38,2.86a2,2,0,0,1-3,1C11.27,36.85,7.5,31.25,6,27l1,0A18,18,0,0,0,18,38a6,6,0,0,1,5-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3.4,19.11c1.14-.88,2.41-1.3,3.42-.29l5.36,5.36A5.7,5.7,0,0,0,13,22L6,15a5.62,5.62,0,0,0-2.6,1.11C1,17.89.86,20.33,1.09,23A6,6,0,0,1,3.4,19.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47,8c0,8.23.2,8.71-.54,10A4,4,0,0,1,43,20H38L28,26V20H21a4,4,0,0,1-4-4V8a4,4,0,0,1,4-4H43A4,4,0,0,1,47,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47,8c0,8.23.2,8.71-.54,10H26a4,4,0,0,1-4-4V4H43A4,4,0,0,1,47,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25,16H21.76A1.76,1.76,0,0,1,20,14.24c0-3.08,3.66-2.94,4-4.24H21a1,1,0,0,1,0-2h3.24A1.76,1.76,0,0,1,26,9.76c0,3.08-3.66,2.94-4,4.24h3A1,1,0,0,1,25,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M31,9v2H29V9a1,1,0,0,0-2,0v3a1,1,0,0,0,1,1h3v2a1,1,0,0,0,2,0V9A1,1,0,0,0,31,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.11,14.55,41.38,10H40a1,1,0,0,1,0-2c3.12,0,3.47-.14,3.85.47s.27.52-3,7A1,1,0,0,1,39.11,14.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M34,15.76l2-8A1,1,0,0,1,38,8.24l-2,8A1,1,0,0,1,34,15.76Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIcon247SupportNwuj4Fhegt);
export default __webpack_public_path__ + "static/media/reshot-icon-24-7-support-NWUJ4FHEGT.59a2e2f0491b50ef38c754446a9de06d.svg";
export { ForwardRef as ReactComponent };